import { render } from "./ThumbnailLink.vue?vue&type=template&id=db56f2a2&scoped=true"
import script from "./ThumbnailLink.vue?vue&type=script&lang=js"
export * from "./ThumbnailLink.vue?vue&type=script&lang=js"

import "./ThumbnailLink.vue?vue&type=style&index=0&id=db56f2a2&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Github\\Wellen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db56f2a2"]])

export default __exports__